import './vendor/owl.js';

// Carousel logos
document.addEventListener("DOMContentLoaded", function() {
  const wrapper = document.querySelector(".logo__wrapper");
  const logos = document.querySelectorAll(".logo__carousel-img");

  let totalWidth = 0;
  logos.forEach(logo => {
    totalWidth += logo.offsetWidth + 200; // Incluye el margen izquierdo
  });

  const duplicateLogos = () => {
    const fragment = document.createDocumentFragment();
    logos.forEach(logo => {
      const clone = logo.cloneNode(true);
      fragment.appendChild(clone);
    });
    wrapper.appendChild(fragment);
  };

  const animateLogos = () => {
    wrapper.style.transition = "none";
    wrapper.style.transform = `translateX(0)`;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        wrapper.style.transition = `transform 30s linear`;
        wrapper.style.transform = `translateX(-${totalWidth}px)`;
      });
    });
  };

  const resetAnimation = () => {
    wrapper.style.transition = "none";
    wrapper.style.transform = `translateX(0)`;
    animateLogos();
  };

  // Añadir todos los manejadores de eventos de transición para compatibilidad
  wrapper.addEventListener("transitionend", resetAnimation);
  wrapper.addEventListener("webkitTransitionEnd", resetAnimation);
  wrapper.addEventListener("mozTransitionEnd", resetAnimation);
  wrapper.addEventListener("oTransitionEnd", resetAnimation);
  wrapper.addEventListener("MSTransitionEnd", resetAnimation);

  duplicateLogos();
  animateLogos();
});

// Slider
jQuery(document).ready(function($) {
  function initializeOwlCarousel(selector, prevButton, nextButton) {
    var owl = $(selector);
    owl.owlCarousel({
      loop: true,
      margin: 10,
      nav: false,
      items: 1,
      lazyLoad: true,
      dots: false
    });

    // Funcionalidad personalizada para los botones de navegación
    $(prevButton).click(function() {
      owl.trigger("prev.owl.carousel");
    });
    $(nextButton).click(function() {
      owl.trigger("next.owl.carousel");
    });

    // Manejar la animación al cambiar de slide
    owl.on("translate.owl.carousel", function(event) {
      var currentSlide = $(event.target).find(".owl-item").eq(event.item.index);
      var previousSlide = $(event.target).find(".owl-item").eq(event.item.index - 1);
      
      // Detener la animación en el slide anterior
      previousSlide.find("dotlottie-player").each(function() {
        this.stop();
        this.seek(0);
      });

      // Iniciar la animación en el slide actual
      var animationContainer = currentSlide.find("dotlottie-player");
      if (animationContainer.length) {
        animationContainer.each(function() {
          this.load(this.src); // Recargar la animación
          this.play(); // Reproducir la animación
        });
      }
    });
  }

  // Inicializar ambos sliders por separado
  initializeOwlCarousel(".casos .slider-container", ".casos .slider-prev", ".casos .slider-next");
  initializeOwlCarousel(".testimonios .slider-container", ".testimonios .slider-prev", ".testimonios .slider-next");
});
// Polyfill para IntersectionObserver si es necesario
